import SliderRow from '@dc-shared-web/components/features/AIConfigDialog/SliderRow'
import { AIConfigModalValues } from '@dc-shared-web/components/features/AIConfigDialog/types'

const TopPRow = ({
  values,
  disabled,
  onChange,
}: {
  values: AIConfigModalValues
  disabled?: boolean
  onChange: (values: AIConfigModalValues) => void
}) => {
  const handleChange = (value: number) => {
    onChange({ ...values, topP: value })
  }

  return (
    <SliderRow
      label='top_p'
      value={values.topP}
      onChange={handleChange}
      disabled={disabled}
    />
  )
}

export default TopPRow
